import React from 'react';
import { Link } from 'react-router-dom';

interface AuthorHeaderProps {
  username?: string;
  name?: string;
  showFullFormat?: boolean;
  className?: string;
  timeText?: string;
}

export function AuthorHeader({ 
  username, 
  name, 
  showFullFormat = true,
  className = "",
  timeText 
}: AuthorHeaderProps) {
  // Always show the full name since privacy is controlled at data level
  const displayName = name || username || 'Someone';
  
  // If no username, show as non-linkable text
  if (!username) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <span className="font-semibold text-sm">Someone</span>
        {timeText && <span className="text-xs text-muted-foreground">{timeText}</span>}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-1">
        <Link 
          to={`/u/${username}`}
          className="font-semibold text-sm hover:text-primary focus-visible:ring-2 focus-visible:ring-black/10 rounded-sm transition-colors"
        >
          {displayName}
        </Link>
        {showFullFormat && (
          <Link 
            to={`/u/${username}`}
            className="text-muted-foreground text-sm hover:text-foreground focus-visible:ring-2 focus-visible:ring-black/10 rounded-sm transition-colors"
          >
            (@{username})
          </Link>
        )}
      </div>
      {timeText && <span className="text-xs text-muted-foreground">{timeText}</span>}
    </div>
  );
}